// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"633":"076deec1","668":"7bec50bf","742":"506770db","763":"506770db","836":"e285d895"}[chunkId] + ".chunk.css";
};